import { saveAs } from 'file-saver';

import Button from 'components/partials/button/button';
import Icons from 'assets/icons';

interface UploadFileAttributes {
  name?: string;
  url?: string;
}

interface UploadFile {
  data?: { attributes?: UploadFileAttributes };
}

interface UploadButtonProps {
  label?: string;
  file?: UploadFile;
}

const UploadButton = ({
  label,
  file,
}: UploadButtonProps): React.JSX.Element => {
  const dowloadFile = (): void => {
    const fileName = file?.data?.attributes?.name;
    const fileUrl = file?.data?.attributes?.url;

    if (!fileUrl || !fileName) {
      console.error('File data is missing');

      return;
    }

    saveAs(fileUrl, fileName);
  };

  return (
    <div className="flex flex-1 mobile:mb-6 xs:mb-8">
      <Button
        onClick={dowloadFile}
        variant="brand-filled"
        iconAfter={<Icons.Download />}
      >
        {label}
      </Button>
    </div>
  );
};

export default UploadButton;
